import React, { useState } from 'react';
import SalesTopSection from '../../../../components/Sales-Information/SalesTopSection';
import SalesSubHeading from '../../../../components/Sales-Information/SalesSubHeading';
import SalesTabPC from '../../../../components/Sales-Information/SalesTabPC';


const SkyHallSpecialRoomPC = () => {

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    {
      main: '/images/SalesInfo/specialHallSalesTwo/img-1.jpg',
      thumbnail: '/images/SalesInfo/specialHallSalesTwo/img-1.jpg'
    },
    {
      main: '/images/SalesInfo/specialHallSalesTwo/img-2.jpg',
      thumbnail: '/images/SalesInfo/specialHallSalesTwo/img-2.jpg'
    },
    {
      main: '/images/SalesInfo/specialHallSalesTwo/img-3.jpg',
      thumbnail: '/images/SalesInfo/specialHallSalesTwo/img-3.jpg'
    },
    {
      main: '/images/SalesInfo/specialHallSalesTwo/img-4.jpg',
      thumbnail: '/images/SalesInfo/specialHallSalesTwo/img-4.jpg'
    },
    {
      main: '/images/SalesInfo/specialHallSalesTwo/img-5.jpg',
      thumbnail: '/images/SalesInfo/specialHallSalesTwo/img-5.jpg'
    }
  ];

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleThumbnailClick = (index) => {
    setCurrentImageIndex(index);
  };



  return (
    <div className="announcement-list-page sale-info-page">
      <SalesTopSection />

      {/* Main Content */}
      <main className="main-content">
        <SalesSubHeading heading="분양가격" heading2="하늘관 특별실" />

        {/* Main Content */}
        <div className="sky-hall-special-room-main-content">
          <div className="sky-hall-special-room-page-content sky-hall-special-room-container">

            <SalesTabPC />

            {/* Gallery */}
            <div className="sky-hall-special-room-gallery">
              <div className="sky-hall-special-room-gallery-main-view">
                <img src={images[currentImageIndex].main} alt="하늘관 특별실 큰 이미지" className="sky-hall-special-room-main-image" />
                <button className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-prev" onClick={handlePrevious}>
                  <img src="/images/Main/arrow-right-white.png" alt="Previous image" />
                </button>
                <button className="sky-hall-special-room-gallery-arrow sky-hall-special-room-gallery-arrow-next" onClick={handleNext}>
                  <img src="/images/Main/arrow-left-white.png" alt="Next image" />
                </button>
              </div>

              <div className="sky-hall-special-room-gallery-thumbnails-container">
                <div className="sky-hall-special-room-gallery-thumbnails">
                  {images.map((image, index) => (
                    <a
                      key={index}
                      href="#"
                      className={`sky-hall-special-room-thumbnail-item ${index === currentImageIndex ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleThumbnailClick(index);
                      }}
                    >
                      <img src={image.thumbnail} alt={`Thumbnail ${index + 1}`} />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Sales Price Section */}
            <div className="sky-hall-special-room-sales-price-section">
              <div className="sky-hall-special-room-sales-price-header">
                <h2 className="sky-hall-special-room-sales-price-title">분양가격</h2>
                <p className="sky-hall-special-room-price-unit">단위: 만원</p>
              </div>

              <div className="sky-hall-special-room-price-table-container sky-hall-special-room-no-bottom-margin">
                <table className="sky-hall-special-room-price-table">
                  <thead>
                    <tr>
                      <th>안치단</th>
                      <th>6</th>
                      <th>5</th>
                      <th>4</th>
                      <th>3</th>
                      <th>2</th>
                      <th>1</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="sky-hall-special-room-row-label">개인</td>
                      <td className="sky-hall-special-room-price-cell">3,000</td>
                      <td className="sky-hall-special-room-price-cell">3,500</td>
                      <td className="sky-hall-special-room-price-cell">4,500</td>
                      <td className="sky-hall-special-room-price-cell">4,500</td>
                      <td className="sky-hall-special-room-price-cell">3,500</td>
                      <td className="sky-hall-special-room-price-cell">2,500</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Management Fee Row - Separate from main table */}
              <div className="sky-hall-special-room-management-fee-row sky-hall-special-room-minimal-gap">
                <div className="sky-hall-special-room-management-fee-label">관리비 (1位)</div>
                <div className="sky-hall-special-room-management-fee-value">8만원/1년</div>
              </div>

              {/* Management Fee Information */}
              <div className="sky-hall-special-room-management-fee-info">
                <div className="sky-hall-special-room-info-icon">
                  <img src="/images/SalesInfo/sales-below-img.png" alt="Info icon" />
                </div>
                <div className="sky-hall-special-room-info-text">
                  <ul>
                    <li>관리비는 물가상승률에 따라 변동될 수 있습니다.</li>
                    <li>관리비는 안치시 5년 선납입니다.</li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>

      </main>
    </div>
  );
};

export default SkyHallSpecialRoomPC; 